export default __webpack_public_path__ + "static/schools-custom-mobile-app-d666ef40735bf236f200565ce7842815.jpg";